import { Checkbox, Divider } from 'antd'
import { sparqlFilterTypes } from 'Services/WeaverUtils'

BooleanFilter = ({ onOk, columnKey }) ->

  <>
    <h5>Boolean filter</h5>
    <Divider style={{ margin: '0 0 10px 0' }} />
    <Checkbox
      data-testid="#{ columnKey }-filter-checkbox"
      onChange={({ target: { checked } }) ->
        onOk(sparqlFilterTypes.EXACT, checked)
      }
    >
      Exact
    </Checkbox>
  </>

export default BooleanFilter
